import { render, staticRenderFns } from "./attributes-listing.vue?vue&type=template&id=32e63113&scoped=true&"
import script from "./attributes-listing.vue?vue&type=script&lang=js&"
export * from "./attributes-listing.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e63113",
  null
  
)

export default component.exports